import {react2panel} from 'common/util/react2panel';

import {BasicBucketPane} from './index';

export const BasicBucketPaneEl = react2panel(`basic-bucket-pane`, BasicBucketPane, {});
